import React, { useMemo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

import { IVR_LIST_API } from "const/apiMethods";
import { transformed_service_reverse_data } from "const";
import { getManagedServices } from "utils/helpers";
import PanelLayout from "components/base/PanelLayout";
import PageHeader from "components/base/PageHeader";
import { Spacer } from "components/base/Spacer";
import IncorporatedNumbersGroup from "./IncorporatedNumbersGroup/IncorporatedNumbersGroup";
import IncorporatedNumbersList from "./IncorporatedNumbersList/IncorporatedNumbersList";
import { checkPermissionsFor } from "store/storeHelpers";


export default (
    {
        trunks,
        ivrList,
        service,
        account,
        authInfo,
        suppliers,
        suppliersLoading,
        groupList,
        groupListLoading,
        suppliersGroupList,
        suppliersGroupLoading,
        supplierList,
        subdestinationList,
        destinationList,
        paymentTermsList,
        currencyList,
        numberList,
        numberCount,
        permissions,
        getTrunks,
        getSuppliers,
        numberListLoading,
        servicePlanList,
        supplierPrefixCount,
        suppliersPrefixList,
        suppliersPrefixLoading,
        supplierListFiltered,

        getIvrList,
        getTemplate,
        getSupplierNumbers,
        getSupplierGroups,
        getGanSuppliersCommonList,
        getIncorporatedNumbersGroups,
        getIncorporatedNumbersList,
        getIncorporatedNumbersSuppliers,
        getAccountManagersInformators,
        clearIncorporatedNumberList,
        showReasonHandler,
    }
) => {

    const rowKey = service ? "ing_key" : "id";

    const location = useLocation();
    const [currentGroup, setCurrentGroup] = useState(null);
    const [groupsFilter, setGroupsFilter] = useState(() => ({
        actual_price: queryString.parse(location.search)["without-payout-only"] === "1"
    }));

    const [numbersFilter, setNumbersFilter] = useState({
        show_allocated_numbers: true,
        show_unallocated_numbers: true,
        show_test_numbers: true,
        show_block_allocation_numbers: true,
    });

    useEffect(() => {
        if (service && checkPermissionsFor(IVR_LIST_API, permissions)) {
            getIvrList();
        }
    }, [service, permissions]);

    const data = useMemo(() => {
        return service ? groupList || [] : suppliersGroupList || [];
    }, [service, groupList, suppliersGroupList]);

    const numberData = useMemo(() => {
        return service ? numberList || [] : suppliersPrefixList || [];
    }, [service, numberList, suppliersPrefixList]);

    const numberDataCount = useMemo(() => {
        return service ? numberCount || [] : supplierPrefixCount || [];
    }, [service, numberCount, supplierPrefixCount]);

    const currentGroupData = useMemo(() => (
        currentGroup
            ? data.find(item => rowKey in item && item[rowKey] === currentGroup)
            : null
    ), [currentGroup, data]);

    const ganSpKey = useMemo(() => {
        return servicePlanList.find((item) => item.gan);
    }, [servicePlanList]);

    const loading = groupListLoading || suppliersGroupLoading || false;
    const roleList = authInfo?.session?.account_user?.role_list;
    const isRatemod = roleList && roleList.length ? (roleList.includes("Ratemod") || roleList.includes("Ratemod (sms)")) : null;
    const isSupervisorSms = roleList && roleList.length ? roleList.includes("Supervisor (sms)") : null;

    const currentServiceTransformed = transformed_service_reverse_data[service];

    const accountManangedServiceList = useMemo(() => {
        return getManagedServices(authInfo)
    }, [authInfo]);

    const serviceIsCorrect = accountManangedServiceList.includes(currentServiceTransformed);

    return (
        <PanelLayout>

            <PageHeader title="Global access numbers"></PageHeader>

            <IncorporatedNumbersGroup
                data={data}
                loading={loading}
                filter={groupsFilter}
                setFilter={setGroupsFilter}
                isRatemod={isRatemod}
                isSupervisorSms={isSupervisorSms}
                {...{
                    rowKey,
                    ivrList,
                    service,
                    trunks,
                    account,
                    ganSpKey,
                    serviceIsCorrect,
                    suppliers,
                    suppliersLoading,
                    permissions,
                    numbersFilter,
                    supplierList,
                    subdestinationList,
                    destinationList,
                    paymentTermsList,
                    currencyList,
                    getTrunks,
                    getTemplate,
                    getSuppliers,
                    getSupplierGroups,
                    getSupplierNumbers,
                    getGanSuppliersCommonList,
                    getIncorporatedNumbersList,
                    getIncorporatedNumbersGroups,
                    getIncorporatedNumbersSuppliers,
                    getAccountManagersInformators,
                    clearIncorporatedNumberList,
                    setCurrentGroup,
                    currentGroup,
                    showReasonHandler,
                    supplierListFiltered
                }}
            />

            <Spacer size={30} />

            <IncorporatedNumbersList
                data={numberData}
                count={numberDataCount}
                loading={numberListLoading}
                filter={numbersFilter}
                setFilter={setNumbersFilter}
                {...{
                    rowKey,
                    service,
                    groupsFilter,
                    permissions,
                    currentGroup,
                    currentGroupData,
                    destinationList,
                    subdestinationList,
                    getSupplierGroups,
                    getSupplierNumbers,
                    getIncorporatedNumbersList,
                    getIncorporatedNumbersGroups,
                    showReasonHandler,
                }}
            />

        </PanelLayout>
    );
};